import { Box, Typography } from '@mui/material';
import * as React from 'react';

interface SuccessMessageProps {
  message?: string;
}

export default function SuccessMessage({
  message
}: SuccessMessageProps): React.ReactElement {
  return (
    <Box sx={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>
      {message && (
        <Typography color='green' variant='body2' sx={{ whiteSpace: 'normal' }}>
          {message}
        </Typography>
      )}
    </Box>
  );
}
